import Vue from "vue";
import Vuex from "vuex";

// Modules
import app from "./app";
import appConfig from "./app-config";
import verticalMenu from "./vertical-menu";
import profile from "./profile";
import pagination from "./pagination";

import createPersistedState from "vuex-persistedstate";

const dataState = createPersistedState({
  paths: ["app.chatQuery", "app.chatDraft", "app.serviceSystemQuery", "app.departmentServiceSystemQuery", "app.conversationSummary", "app.pushedToRag"],
});

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    app,
    appConfig,
    verticalMenu,
    profile,
    pagination,
  },
  strict: process.env.DEV,
  plugins: [dataState],
});
